<div class="liner">
  <div class="ttl_form">
    {{ headerText }}
    <span *ngIf="isRequired">*</span>
  </div>

  <div class="list_radio">
    <label *ngFor="let item of itemsSource" class="checkbox">
      <input
        type="checkbox"
        [checked]="itemIsChecked(item)"
        [value]="item.value"
        (change)="onChangeEvent($event, item)"
      />
      <div class="checkbox__text">
        {{ item.name }}
      </div>
    </label>
  </div>
</div>
